import React, { useRef } from 'react';
import Header from '../../components/layout/Header';
import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import RequestDemoForm from './RequestDemoForm';
import PricingSection from './PricingSection';
import Footer from '../../components/layout/Footer';
import styled from 'styled-components';

const FormSectionWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.background}; 
  padding-bottom: 3rem;
`;

const SectionWrapper = styled.div`
  scroll-margin-top: 100px;
`;

const HomePage = ({ user }) => { 
  const formRef = useRef(null);

  const handleScrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <Header user={user} />
      <main>
        <SectionWrapper id="funcionalidades">
            <HeroSection onCTAClick={handleScrollToForm} />
        </SectionWrapper>
        
        {/* Adicionei o ID diferenciais para o link "Por que nós?" funcionar */}
        <SectionWrapper id="diferenciais">
            <FeaturesSection />
        </SectionWrapper>

        {/* Adicionei o ID planos para o link "Planos" funcionar */}
        <SectionWrapper id="planos">
            <PricingSection />
        </SectionWrapper>
        
        <FormSectionWrapper>
           <RequestDemoForm ref={formRef} />
        </FormSectionWrapper>
      </main>
      <Footer />
    </>
  );
};

export default HomePage;